import { defineMessages } from 'react-intl';

export default defineMessages({
    unableToDownload: {
        id: 'twia.commercial.additionalinformation.documentupload.Unable to Download22',
        defaultMessage: 'Unable To Download Documents, Please Try Again Later',
    },
    failedToRetrievedocuments: {
        id: 'twia.commercial.additionalinformation.documentupload.Failed to retrieve buildings',
        defaultMessage: 'The document(s) could not be retrieved. Please try again later.',
    },
    uploadFailedMessage: {
        id: 'twia.commercial.additionalinformation.documentupload.The document could not be uploaded. Please try again later or contact TWIA at (800) 788-8247.',
        defaultMessage: 'The document could not be uploaded. Please try again later or contact {uwCompanyName} at {contactNumber}.',
    },
    buildingRequired: {
        id: 'twia.commercial.additionalinformation.documentupload.Please select a Building for the document you are uploading.',
        defaultMessage: 'Please select a Building for the document you are uploading.',
    },

});
